import { Patch } from "rfc6902";
import { VARIANT_UPDATEABLE_KEYS } from "./VariantUpdateableKeys";

/**
 * Type guard for a variant patch, i.e. an rfc6902 patch limited to the operations a
 * variant is allowed to apply to its master.
 *
 * @param obj - The object to check
 * @returns true if the object is an array containing only remove and replace operations
 */
export const isVariantPatch = (obj: unknown): obj is Patch => {
  if (!Array.isArray(obj)) return false;

  return obj.every((op) => {
    if (typeof op !== "object" || op === null) return false;

    const chkOp = op as { op?: unknown; path?: unknown; value?: unknown };
    if (
      typeof chkOp.path !== "string" ||
      !chkOp.path.startsWith("/") ||
      /~(?:[^01]|$)/.test(chkOp.path)
    ) {
      return false;
    }
    // Check first token is valid to be updated
    const firstToken = chkOp.path.slice(1).split("/")[0].replace(/~1/g, "/").replace(/~0/g, "~");
    if (!VARIANT_UPDATEABLE_KEYS.some((key) => key === firstToken)) return false;
    // Check if the operation is one of the allowed types: add, remove, replace
    if (!["add", "remove", "replace"].includes(chkOp.op as string)) return false;
    // Check new value has been specified
    if (chkOp.op === "add" || chkOp.op === "replace") {
      if (chkOp.value === undefined) return false;
    }
    // Everything is good
    return true;
  });
};
